<template>
  <div class="s-multi-img-slider">
    <swiper
      ref="swiperImageSlider"
      :navigation="{
        nextEl: '.s-multi-img-slider__next',
        prevEl: '.s-multi-img-slider__prev',
      }"
      :pagination="{
        el: '.s-multi-img-slider__pagination',
        type: 'bullets',
        clickable: true,
      }"
      :slides-per-view="slidesPerView"
      :space-between="32"
      :breakpoints="sliderBreakpoints">
      <swiper-slide v-for="(record, index) in slidesData" :key="index">
        <slot name="card-slide" :record="record" :record-index="index"></slot>
        <slot name="image-slide" :record="record" :record-index="index"></slot>
      </swiper-slide>

      <div class="swiper__nav">
        <div
          v-if="desktop"
          class="swiper-button-prev s-multi-img-slider__prev"></div>
        <div class="swiper-pagination s-multi-img-slider__pagination"></div>
        <div
          v-if="desktop"
          class="swiper-button-next s-multi-img-slider__next"></div>
      </div>
    </swiper>
  </div>
</template>

<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue'
import useViewport from '../../features/viewport.js'
const { desktop } = useViewport()

defineProps({
  slidesData: {
    default() {
      return []
    },
    type: Array,
  },
  slidesPerView: {
    default: 4,
    type: Number,
  },
  sliderBreakpoints: {
    default() {
      return {}
    },
    type: Object,
  },
})
</script>
